export const COLUMNS = [
  {
    Header: "Field Name",
    Footer: "Field Name",
    accessor: "fieldName",
  },
  {
    Header: "Display Name",
    Footer: "Display Name",
    accessor: "displayName",
  },
  {
    Header: "Data Type",
    Footer: "Data Type",
    accessor: "dataType",
  },
  {
    Header: "Field Data Type",
    Footer: "Field Data Type",
    accessor: "fielddatatype",
  },
  {
    Header: "Is Ident",
    Footer: "IsIdent",
    accessor: "isident",
  },
  {
    Header: "Is Mobile Field",
    Footer: "Is Mobile Field",
    accessor: "IsMobileField",
  },
  {
    Header: "Is Display",
    Footer: "Is Display",
    accessor: "isFormView",
  },
  {
    Header: "Is Required",
    Footer: "Is Required",
    accessor: "isrequired",
  },
  {
    Header: "Action",
    Footer: "Action",
    accessor: "action",
  },
];
